export const RADAR_SIDEPANEL_WIDTH = 330;

export const RADAR_DISPLAY_OPTIONS = {
  TRAIT: 'trait',
  PERFORMANCE: 'performance',
  BOTH: 'both',
};

export const RADAR_STATE = {
  LOADING: 'loading',
  EMPTY: 'info',
  ERROR: 'error',
};

export const RADAR_TOOLTIP_DELAY = 300;
